'use strict';

import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { TrackingConstants, fetchUpdatedFilterState } from '../cfs-search-slice';

import analytics from '../../../../utils/analytics';

export const RangeFilter = ({ filterItems, filterName, label }) => {
	const defaultValue = '*';
	const dispatch = useDispatch();

	const [minValue, setMinValue] = useState(defaultValue);
	const [maxValue, setMaxValue] = useState(defaultValue);

	const [minItems, setMinItems] = useState(filterItems);
	const [maxItems, setMaxItems] = useState(filterItems);

	const onApplyClicked = (e) => {
		let range;
		if (minValue !== defaultValue || maxValue !== defaultValue) {
			range = `${minValue}-${maxValue}`;
		}

		if (minValue !== defaultValue) {
			analytics.trackEvent(TrackingConstants.Categories.Added, `${filterName}Min`, minValue);
		}

		if (maxValue !== defaultValue) {
			analytics.trackEvent(TrackingConstants.Categories.Added, `${filterName}Max`, maxValue);
		}

		dispatch(fetchUpdatedFilterState({
			name: filterName,
			value: range ?? ''
		}));
	};

	const onMinChanged = (e) => {
		const newValue = e.target.value;
		const newMaxItems = newValue === defaultValue
			? filterItems
			: $.grep(filterItems, (item) => item.value >= newValue);

		setMinValue(newValue);
		setMaxItems(newMaxItems);
	}

	const onMaxChanged = (e) => {
		const newValue = e.target.value;
		const newMinItems = newValue === defaultValue
			? filterItems
			: $.grep(filterItems, (item) => item.value <= newValue);

		setMaxValue(newValue);
		setMinItems(newMinItems);
	}

	const minOptions = minItems.map((item) => (
		<option key={item.value} value={item.value}>{item.displayText}</option>
	));

	const maxOptions = maxItems.map((item) => (
		<option key={item.value} value={item.value}>{item.displayText}</option>
	));

	return (
		<div className="search-filter-content__range">
			<h3 className="search-filter-content__range__heading">{label}</h3>
			<div className="grid-x grid-margin-x">
				<div className="cell small-6">
					<label className="search-filter-content__range__label">From:</label>
					<select className="search-filter-content__range__select" onChange={onMinChanged}>
						<option key={defaultValue} value={defaultValue}>Any</option>
						{minOptions}
					</select>
				</div>
				<div className="cell small-6">
					<label className="search-filter-content__range__label">To:</label>
					<select className="search-filter-content__range__select" onChange={onMaxChanged}>
						<option key={defaultValue} value={defaultValue}>Any</option>
						{maxOptions}
					</select>
					<button className="search-filter-content__range__apply button" onClick={onApplyClicked}>Apply</button>
				</div>
			</div>
		</div>
	);
}